module.exports = __webpack_public_path__ + "a8260a70ba0ed26df31310cc7ae9d0f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room8/audio1/one-page-slide-Selfless-In-The-Bath-of-Lava.jpg
// module id = 903
// module chunks = 0